<template lang="">
    <div>
         <!--begin::Mixed Widget 14-->
  <div class="card card-custom card-stretch gutter-b d-none">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title font-weight-bolder">Ranking de la Gestión Municipal 2021</h3>
      <div class="card-toolbar">
       
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body d-flex flex-column">
      <div class="flex-grow-1">
        <apexchart
          :options="chartOptions"
          :series="series"
          type="radialBar"
        ></apexchart>
      </div>
      <div class="pt-5">
        <p class="text-center font-weight-normal font-size-lg pb-7">
          Completado del proceso actual de Medición <br />
        </p>
        <a
          href="#"
          :disabled="true"
          class="btn btn-success btn-shadow-hover font-weight-bolder w-100 py-3"
          >Responder Boletas</a
        >
      </div>
    </div>
    <!--end::Body-->
  </div>
  <!--end::Mixed Widget 14-->



      <v-row dense>
         <v-col v-if="boletas.length<=0" cols="12">
            <v-alert
                text
                prominent
                type="error"
                icon="mdi-alert"
                dense
                small
                >
                    <p class="mt-3">No hay boletas asignadas para su municipalidad.</p> 
                </v-alert>
        </v-col>

        <v-col v-for="boleta in boletas" :key="boleta.id" cols="12" md="6" sm="6" xs="12">
          <v-card
            color="#26c6da"
            dark
            class="mx-auto"
          >
           
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5">
                  {{boleta.anioMedicion}}
                </v-list-item-title>
                <v-list-item-subtitle class="text-h6">{{boleta.nombreIndice}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
           

            <v-card-subtitle>{{boleta.descripcion}}</v-card-subtitle>
            
            <v-card-text v-if="1>1">
              <apexchart
                :options="chartOptions"
                :series="series"
                type="radialBar"
              ></apexchart>
            </v-card-text>

            <v-card-actions>
              <v-btn text 
                :to="{
                    name: 'boletas-responder-especifica',
                    params: {
                        boletaMuniId: boleta.id,
                        idBoleta: boleta.boletasId,    
                        idPeriodo: boleta.periodoMedicionId}
                }">
                  Responder Boleta
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        </v-row>
    </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";


import { OBTENER_BOLETAS_POR_MUNI } from "@/core/services/store/boletas/boletamuni.module";
export default {
    name: "DashboardInformador",
    data() {
        return {
        chartOptions: {},
        series: [0],
        boletas:[],
        //parameters,
        };
    },
    components: {
        
    },

    methods:{
      

       //!Obtener boletas asignadas a la municipalidad con lo que se logueó
        async obtenerBoletasPorMuni(){
            this.boletas=[];
            //this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS_POR_MUNI, this.currentUser.municipiosId)
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                //this.ddBoletasLoading=false;

               // console.log(this.boletas)
               
            }
            )
            .catch(() => {
                //this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },
    },
    computed: {
        ...mapGetters(["layoutConfig"]),
        ...mapGetters(["currentRoles"]),
        ...mapGetters(["currentUser"]),
    },
    created(){
      this.obtenerBoletasPorMuni();
    },
    mounted() {
      

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Inicio" }]);
    this.chartOptions = {
      chart: {
        height: 100,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: "65%"
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
              fontWeight: "700"
            },
            value: {
              color: this.layoutConfig("colors.gray.gray-700"),
              fontSize: "30px",
              fontWeight: "700",
              offsetY: 12,
              show: true
            }
          },
          track: {
            background: this.layoutConfig("colors.theme.light.success"),
            strokeWidth: "100%"
          }
        }
      },
      colors: [this.layoutConfig("colors.theme.base.success")],
      stroke: {
        lineCap: "round"
      },
      labels: ["Progress"]
    };
  },
}
</script>
<style lang="">
    
</style>